/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { memo } from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Icon, Typography } from '@mui/material';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        notification: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            color: theme.palette.primary.main,
        },
        notificationText: {
            margin: theme.spacing(3, 0, 3, 0.5),
            fontSize: 18,
        },
        notificationTextSmall: {
            margin: theme.spacing(0, 0, 0, 0.5),
            fontSize: 15,
        },
        warning: {
            color: theme.palette.coral.main,
        },
        wrap: {
            alignItems: 'flex-start',
        },
    }),
);

interface InnerNotificationProps {
    textTranslatePath: string;
    textParam?: Record<string, unknown>;
    icon?: string;
    small?: boolean;
    warning?: boolean;
    color?: string;
    noIcon?: boolean;
    isWrap?: boolean;
}

const InnerNotification = (props: InnerNotificationProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { textTranslatePath, noIcon, icon, small, warning, textParam, color, isWrap } = props;

    return (
        <div className={clsx(classes.notification, isWrap ? classes.wrap : null)}>
            {noIcon ? null : icon ? (
                <Icon className={warning ? classes.warning : null} style={{ color: color ? color : null }}>
                    {icon}
                </Icon>
            ) : (
                <Icon className={warning ? classes.warning : null} style={{ color: color ? color : null }}>
                    {'info'}
                </Icon>
            )}
            <Typography
                className={clsx(
                    small ? classes.notificationTextSmall : classes.notificationText,
                    warning ? classes.warning : null,
                )}
                noWrap={!isWrap}
                color={color ? color : null}
                variant="h6"
            >
                {t(textTranslatePath, textParam)}
            </Typography>
        </div>
    );
};

export default memo(InnerNotification);
